import { AgentOSType } from "../../../../../../client/utils";

const getMobileAppLink = (osType: AgentOSType | null) => {
    switch (osType) {
        case AgentOSType.ANDROID:
            return (
                "https://play.google.com/store/apps/details?id=com.premiereradio.android.c2c" +
                "&feature=search_result#?t=W251bGwsMSwyLDEsImNvbS5wcmVtaWVyZXJhZGlvLmFuZHJvaWQuYzJjIl0."
            );
        case AgentOSType.IOS:
            return "http://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=330213424&mt=8&uo=6";
        default:
            return null;
    }
};

export const CoastShowAudioBoxMP3DownloadNotice = ({ osType }: { osType: AgentOSType | null }) => {
    const mobileAppLink = getMobileAppLink(osType);

    if (!mobileAppLink) {
        return null;
    }

    return (
        <section className="audiobox-section download-notice">
            <p className="audiobox-section-value">
                <strong>IMPORTANT:</strong> Some mobile devices do not download MP3s. If this is the case, please use
                your desktop computer or <a href={mobileAppLink}>download our mobile app</a>.
            </p>
        </section>
    );
};
